import { render, staticRenderFns } from "./status-form-personal.vue?vue&type=template&id=76687c57&scoped=true"
import script from "./status-form-personal.vue?vue&type=script&lang=js"
export * from "./status-form-personal.vue?vue&type=script&lang=js"
import style0 from "./status-form-personal.vue?vue&type=style&index=0&id=76687c57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76687c57",
  null
  
)

export default component.exports